import requests from 'api/index';

const prefixURL = '/support';

export default {
  getSupportList: payload =>
    requests.getJSONP(`${prefixURL}/rest/v1/sp_bizcntc/list?suborgCd=${payload.suborgCd}&compCd=${payload.compCd}`),
};
